import { post } from './request'
import t from '../helpers/i18n'

const uploadFile = async (
  key,
  type,
  filename,
  content_type,
  dataGetter,
  onProgress
) => {
  return post('/upload/' + type, { content_type, filename })
    .then((response) => dataGetter().then((data) => ({ ...response, data })))
    .then(
      (response) =>
        new Promise((resolve, reject) => {
          const request = new XMLHttpRequest()
          request.open('PUT', response.signedRequest)
          request.setRequestHeader('Content-Type', content_type)
          request.setRequestHeader(
            'Content-Disposition',
            `inline; filename="${filename}"`
          )

          if (onProgress) {
            request.upload.addEventListener('progress', (event) => {
              const percent = Math.floor((event.loaded / event.total) * 100)
              onProgress(key, percent)
            })
          }

          request.addEventListener('load', () => {
            if (request.status === 200) resolve(response.id)
            else reject({ message: 'Upload failed', status: request.status })
          })

          request.addEventListener('error', (event) => {
            console.error(event)
            reject({ message: t('Upload error') })
          })

          request.send(response.data)
        })
    )
}

const uploadFileHelper = async (files, paths, onProgress) => {
  const output = {}
  const promises = Object.keys(files).reduce((final, key) => {
    if (paths[key]) {
      const file = files[key]
      if (file instanceof Array) {
        const arrayResult = Array(file.length).fill()
        const progress = Array(file.length).fill(0)
        const handleProgress = (index, percent) => {
          progress[index] = percent
          onProgress(
            key,
            Math.round(
              progress.reduce((total, percent) => total + percent, 0) /
                progress.length
            )
          )
        }
        file.forEach((element, index) => {
          if (element.id) {
            handleProgress(index, 100)
            arrayResult[index] = { id: element.id, name: element.name, size: element.size, type: element.type }
          } else {
            const promise = uploadFile(
              index,
              paths[key],
              element.name,
              element.type,
              element.get,
              handleProgress
            ).then((id) => (arrayResult[index] = { id, name: element.name, size: element.size, type: element.type }))
            final.push(promise)
          }
        })
        output[key] = arrayResult
      } else {
        const promise = uploadFile(
          key,
          paths[key],
          file.value.name,
          file.value.type,
          file.value.get,
          onProgress
        ).then((id) => (output[key] = { id, name: file.value.name }))
        final.push(promise)
      }
    }
    return final
  }, [])

  onProgress(true)
  return Promise.all(promises)
    .then(() => output)
    .finally(() => onProgress(false))
}

const getFileData = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsArrayBuffer(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
  })

export { uploadFileHelper, getFileData }
